import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import RoofingHero from '../components/Roofers/RoofingHero'
import WhyChooseOLM from '../components/Roofers/WhyChooseOLM'
import HowItWorks from '../components/Roofers/HowItWorks'
import MailerSamples from '../components/Roofers/MailerSamples'
import FreeReportSection from '../components/Roofers/FreeReportSection'
import LeadCaptureForm from '../components/Roofers/LeadCaptureForm'
import NeighborhoodLeads from '../components/Roofers/NeighborhoodLeads'
import CtaBanner from '../components/Roofers/CtaBanner'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import WhyDirectMail from '../components/Roofers/WhyDirectMail'

export default function DirectMailRoofers({ data }) {
    return (
        <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
            <Header meta={data?.yoast_head} />
            <RoofingHero />
            <WhyDirectMail />
            <MailerSamples />
            <FreeReportSection />
            <LeadCaptureForm />
            <WhyChooseOLM />
            <HowItWorks />
            <NeighborhoodLeads />
            <CtaBanner />
        </LandingPageWrapper>
    )
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps() {
    // const data = { } //await GeneralAPI.getFrontPage()

    const page = await GeneralAPI.getPageBySlug('/direct-mail-for-roofers')
    const data = page ? page[0] : {}

    const { banners } = await GeneralAPI.getACFBanners()
    data.banners = banners

    return {
        props: {
            data,
            hideTopNav: true,
            hideCartButton: true,
            hideLoginButton: true,
            phoneNumber: '978-893-5890',
        },
        revalidate: 10, // In seconds
    }
}
